module.exports = __webpack_public_path__ + "static/media/loading-image.2f1351ec.png";